
import * as pdfjsLib from 'pdfjs-dist';

// Cache of loaded PDFDocumentProxy objects
const cache = new Map(); // docId -> PDFDocumentProxy

export class PDFRenderer {
    static async loadDocument(docId, data) {
        // data should be ArrayBuffer or Uint8Array
        // We make a copy if we think it might be detached? 
        // Or we assume the caller gave us a usable buffer.

        // PDF.js uses a worker by default. It sends data to worker.
        const loadingTask = pdfjsLib.getDocument(data);
        const pdfDoc = await loadingTask.promise;
        cache.set(docId, pdfDoc);
        return pdfDoc.numPages;
    }

    static async renderPage(docId, pageIndex, canvas, scale = 1.5) {
        const pdfDoc = cache.get(docId);
        if (!pdfDoc) throw new Error(`Document ${docId} not loaded in renderer`);

        // pageIndex is 0-based
        const page = await pdfDoc.getPage(pageIndex + 1); // PDF.js is 1-based

        const viewport = page.getViewport({ scale });

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const context = canvas.getContext('2d');

        const renderContext = {
            canvasContext: context,
            viewport: viewport
        };

        await page.render(renderContext).promise;
    }

    static async getThumbnailDimensions(docId, pageIndex, width = 200) {
        const pdfDoc = cache.get(docId);
        if (!pdfDoc) return { width, height: 300 }; // fallback

        const page = await pdfDoc.getPage(pageIndex + 1);
        const viewport = page.getViewport({ scale: 1 });
        const scale = width / viewport.width;

        return {
            width,
            height: viewport.height * scale
        };
    }
}
